import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

// styles
import './ConsumptionDetailMenu.Styles.css';

// import functions
import * as ComponentFunctions from './ConsumptionDetailMenu.Functions';
import { Button, Tooltip } from '@fluentui/react-components';
import { ChevronDoubleRight20Regular, ChevronRight20Regular } from '@fluentui/react-icons';

/**
 * Acciones rápidas del encabezado del detalle.
 *
 * La marca de seguimiento vivía también acá, con su propio botón y sus toasts.
 * Ahora es una de las tres condiciones del consumo y se maneja en la sección
 * "Condición y agrupación", junto a la discontinuación temprana y la agrupación:
 * un mismo dato gobernado desde dos lugares es lo que vuelve confusa la pantalla.
 */
const ConsumptionDetailMenu = (props: ComponentFunctions.Props) => {
    const { t } = useTranslation();

    const dispatchChangeStatus = (setAll: boolean) => {
        props.ChangeStatus(props.ProtocolId, props.ProtocolConsumptionId, 5, setAll);
    };

    if (props.Consumption?.groupingId) {
        return null;
    }

    return (
        <div className="consumption-detail-menu-container">
            <Tooltip content={t('consumptionDetailMenu.ignore.tooltip', 'Ignore this consumption')} relationship="label">
                <Button appearance="subtle" onClick={() => dispatchChangeStatus(false)} icon={<ChevronRight20Regular />}>{t('consumptionDetailMenu.ignore.button', 'Ignore')}</Button>
            </Tooltip>
            <Tooltip content={t('consumptionDetailMenu.ignoreAll.tooltip', 'Ignore all consumptions of this type')} relationship="label">
                <Button appearance="outline" onClick={() => dispatchChangeStatus(true)} icon={<ChevronDoubleRight20Regular />}>{t('consumptionDetailMenu.ignoreAll.button', 'Ignore all')}</Button>
            </Tooltip>
        </div>
    );
};

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(ConsumptionDetailMenu as any);
